module.exports = __webpack_public_path__ + "img/calendar.743c632a.png";